module.exports = __webpack_public_path__ + "img/9788960172562.e442c4a4.jpg";